var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yield-bump-banner"},[_c('div',{staticClass:"banner-image"}),_vm._v(" "),_c('div',[_vm._v("\n    A "+_vm._s(_vm.formattedYieldBumpRate)+" yield bump will be applied!\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }